import { Injectable } from '@angular/core';
import { CbtserviceService } from './cbtservice.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Util } from '../interceptors/util';
@Injectable({
  providedIn: 'root'
})
export class SystemCheckService {

  readonly rootS3DBURL = environment.CBTS3APIURL;
  req_headers: HttpHeaders;
  constructor(private cbtservice: CbtserviceService, private http: HttpClient, private util: Util) {

    // this.initListener();
  }

  public async matchFaces(originalImageData: string, smilingImageData: string){
    const requestBody = {
      candidate: {
        passporturl: originalImageData,
        overrideai: true
      },
      imgDataURL: smilingImageData
    };

    return this.tryPostWithBackoff(`${environment.aiServerUrl}`, requestBody, { headers: this.req_headers });
  }

  public async analyzeImageQuality(imageData: string): Promise<any> {
    // const requestBody = {
    //   ImageData: imageData,
    //   Format: "image/jpeg",
    //   UseFaceDetection: true
    // };
    const requestBody = {
      imgDataURL: imageData,
    };

    return this.tryPostWithBackoff(`${environment.aiServerUrl}checkface`, requestBody, { headers: this.req_headers });
  }

  private async tryPostWithBackoff(url: string, data: any, options: any): Promise<any> {
    let overallBurstAttempts = 0;
    const maxWaitTime = 10 * 60 * 1000; // 10 minutes max wait time for cold start
    const startTime = Date.now();

    while (true) {
      try {
        return await this.cbtservice.tryPost(url, data, options, 3);
      } catch (error) {
          if (Date.now() - startTime > maxWaitTime) 
          {
            console.error('Maximum wait time exceeded. Cold start timeout.');
            return null;
          }
      }
      overallBurstAttempts++;

      // Wait with exponential backoff before starting next burst
      const waitTime = Math.min(overallBurstAttempts * 2.71828 * 1000, 10*1000); // Max 30 seconds
      console.log(`Max attempts exceeded. Waiting ${waitTime}ms before retrying...`);
      await this.util.sleep(waitTime);
    }
  }
}